import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { Input } from "./Input";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Loading from "./Loading";
import { spacesUpdate } from "../services/spaces";
import { useEffect } from "react";

const SpacesUpdate = ({
  item,
  open,
  onClose,
  refetch,
}: {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  item: {
    id: string;
    name: string;
    description?: string;
  };
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: spacesUpdate,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Espaço cadastrado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { values, handleSubmit, handleChange, setFieldValue } = useFormik({
    initialValues: {
      id: "",
      name: "",
      description: "",
    },
    onSubmit: (values) => {
      mutate(values);
    },
  });

  useEffect(() => {
    if (item) {
      setFieldValue("id", item?.id);
      setFieldValue("name", item?.name);
      setFieldValue("description", item?.description);
    }
  }, [item]);

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Atualizar espaço
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="name"
              name="name"
              label="Nome"
              placeholder="Digite o nome"
              type="text"
              fullWidth
              size="small"
              value={values.name}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="description"
              name="description"
              label="Descrição"
              placeholder="Digite a descrição"
              type="text"
              fullWidth
              size="small"
              value={values.description}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={() => handleSubmit()}
            >
              Atualizar espaço
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default SpacesUpdate;
